<!-- Footer Start -->
<footer class="cyclops footer2 py-5">
  <div class="container">
    <div class="row gx-5 gy-4 justify-content-between">

      <!-- Logo Column -->
      <!-- Logo Column -->
<div class="col-lg-2 col-md-6 col-sm-12">
  <div class="logo-sec text-center text-lg-start">

    <img src="assets/images/logo/Cyclops-logo1.png"
         width="150"
         alt="Cyclops Logo"
         class="img-fluid footer-logo mb-3">

    <!-- Social Icons -->
   <div class="col-lg-2 col-md-6 col-sm-12">
  <div class="logo-sec text-center">

    <img src="assets/images/logo/Cyclops-logo1.png"
         width="150"
         alt="Cyclops Logo"
         class="img-fluid footer-logo mb-3">

    <!-- Social Icons -->
    <div class="footer-social" style="width: 180px;">
      
      <div class="social-icons">
        <span class="follow-text">Follow Us</span>
        <a href="https://www.linkedin.com/company/cyclops-defense/" target="_blank" aria-label="LinkedIn">
          <i class="fa-brands fa-linkedin-in"></i>
        </a>

        <a href="https://x.com/Cyclops_Defense" target="_blank" aria-label="X">
          <i class="fa-brands fa-x-twitter"></i>
        </a>
      </div>
    </div>

  </div>
</div>

  </div>
</div>

      <!-- Main Links -->
      <div class="col-lg-2 col-md-6 col-sm-6">
        <h5 class="text-white" style="padding-bottom: 20px;">Quick Links</h5>
        <ul class="footer-lists op-text list-unstyled">
          <li><a routerLink="/about-us" class="text-white">About Us</a></li>
          <li><a routerLink="/solutions" class="text-white">Solutions </a></li>
          <!-- <li><a routerLink="/whoweserve" class="text-white">Who We Serve</a></li> -->
          <li><a routerLink="/whycyclops" class="text-white">Why Cyclops</a></li>
          <li><a routerLink="/contact-us" class="text-white">Contact Us</a></li>
        </ul>
      </div>

      <!-- Get in Touch -->
      <div class="col-lg-2 col-md-6 col-sm-6">
        <h5 class="text-white" style="padding-bottom: 20px;">Get in Touch</h5>
        <ul class="footer-lists op-text list-unstyled" s>
          <li style="text-transform: none;">
            Have a question , proposal , or request?
            <a href="mailto:info&#64;cyclopsdefense.com" class="text-white text-decoration-underline">
              Click here
            </a>
            to contact us - we'll get back to you shorlty .
          </li>
        </ul>
      </div>

      <!-- Headquarters -->
      <div class="col-lg-3 col-md-6 col-sm-6">
        <h5 class="text-white" style="padding-bottom: 20px;">Headquarters</h5>
        <ul class="footer-lists op-text list-unstyled">
          <li><strong>U.S. office:</strong>
           <br> Warren, Michigan<br>
            Washington, D.C.</li>
          <li><strong>Middle East Office:</strong><br>Beirut, Lebanon</li>
          <li>
            <i class="fa fa-envelope me-2"></i>
            <a href="mailto:info&#64;cyclopsdefense.com" class="text-white"
              style="padding: 10px;">info&#64;cyclopsdefense.com</a>
          </li>
        </ul>
      </div>

    </div>
  </div>
</footer>
<!-- Footer End -->
<app-tap-to-top></app-tap-to-top>